import { motion } from "framer-motion";
import { Church, Anchor, Flame, Heart, MoonStar, FlaskConical, Landmark, Coins, Waves } from "lucide-react";
import { CHARACTERS } from "@/lib/site";
import { Reveal, SectionHead } from "./shared";

const ICONS = {
  church: Church,
  anchor: Anchor,
  flame: Flame,
  heart: Heart,
  moon: MoonStar,
  flask: FlaskConical,
  landmark: Landmark,
  coins: Coins,
  waves: Waves,
};

export default function Personaggi() {
  return (
    <section id="personaggi" className="parchment-texture relative py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          light
          kicker="I Personaggi"
          title="Carte dal mazzo del lago"
          sub="Nove destini legati da un filo che attraversa sedici secoli: santi, imperatori, creature, amanti, la strega — e il lago stesso."
        />

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {CHARACTERS.map((c, i) => {
            const Icon = ICONS[c.icon];
            return (              <Reveal key={c.id} delay={i * 0.08}>
                <motion.article
                  data-testid={c.testid}
                  whileHover={{ y: -8 }}
                  transition={{ type: "spring", stiffness: 180, damping: 18 }}
                  className="card-parchment group relative h-full overflow-hidden rounded-xl p-6 sm:p-8"
                >
                  <span className="pointer-events-none absolute -right-4 -top-6 font-display text-[7rem] leading-none text-gold/10 transition-colors duration-500 group-hover:text-gold/20">
                    {c.numeral}
                  </span>
                  <div className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/50 bg-lake-deep">
                    <Icon className="h-5 w-5 text-gold-shimmer" strokeWidth={1.6} />
                  </div>
                  <h3 className="mt-5 font-serif text-2xl text-ink-dark">{c.name}</h3>
                  <p className="mt-1 text-sm font-medium text-lake-teal">{c.role}</p>
                  <p className="mt-0.5 text-[11px] uppercase tracking-[0.2em] text-ink-muted">{c.faction}</p>
                  <div className="gold-line my-5 w-full opacity-60" />
                  <p className="text-sm leading-relaxed text-ink-muted">{c.description}</p>
                  <div className="mt-6 h-px w-0 bg-gold transition-all duration-500 group-hover:w-full" />
                </motion.article>
              </Reveal>
            );
          })}

        </div>
      </div>
    </section>
  );
}
